import { SignalDoc } from "@megaron/docs-contracts";
import { notificationPermissionMap, NotificationType } from "@megaron/notifications-contracts";

import { signalActionLabel, signalTypeLabel } from "./signalActionLabel";

const docSignalNotificationLabels: Record<string, string> = {
  unreadInvoice: "Nowa faktura",
  assignedTicket: notificationPermissionMap.supportTicketAssigned.permissionName,
  regionCustomer: notificationPermissionMap.crmRegionAssigned.permissionName,
};

const isNotificationType = (signalType: string): signalType is NotificationType =>
  signalType in notificationPermissionMap;

export const signalDisplayLabel = (signal: SignalDoc): string => {
  if (isNotificationType(signal.signalType)) {
    return notificationPermissionMap[signal.signalType].permissionName;
  }

  return docSignalNotificationLabels[signal.signalType] ?? signalActionLabel(signal);
};

export const signalTypeDisplayLabel = (signalType: string): string => {
  if (isNotificationType(signalType)) {
    return notificationPermissionMap[signalType].permissionName;
  }

  return docSignalNotificationLabels[signalType] ?? signalTypeLabel(signalType);
};
